module.exports = __webpack_public_path__ + "static/img/water_blue.7230049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/serviceArea/water_blue.png
// module id = +iZm
// module chunks = 66